export type ChargingPolicy = {
  label: string;
  description?: string;
  currency: string;
  sessionThresholds: SessionThresholds;
  tariffRules?: TariffRule[];
  // TODO: Review the below with OP models
  name?: string;
  status?: string;
  pricing?: string;
  associatedGroups?: string[];
};

export type SessionThresholds = {
  minTimeMinutes?: number;
  maxTimeMinutes?: number;
  minKwhConsumed?: number;
  maxKwhConsumed?: number;
  maxCost?: number;
};

export type Tariff = {
  __initial?: boolean;
  components: TariffComponent[];
  descriptions?: TariffDescription[];
};

export type TariffRule = {
  __id?: string;
  __initial?: boolean;
  authorizationMethods: AuthorizationMethod[];
  customerGroups: string[];
  tariff: Tariff;
  validityPeriod: {
    enabled: boolean;
    start?: Date;
    end?: Date;
  };
};

export type TariffDescription = {
  __id: string;
  __initial?: boolean;
  language: string;
  text: string;
};

export type TariffComponent = {
  __id?: string;
  __initial?: boolean;
  price?: Price;
  restrictions?: {
    enabled: boolean;
    timeOfDay?: {
      enabled: boolean;
      start?: number;
      end?: number;
    };
    daysOfWeek?: {
      enabled: boolean;
      values: string[];
    };
    date?: {
      enabled: boolean;
      start?: Date;
      end?: Date;
    };
    duration?: {
      enabled: boolean;
      unit: TimeUnit;
      min?: string;
      max?: string;
    };
    energy?: {
      enabled: boolean;
      min?: string;
      max?: string;
    };
  };
};

export type CustomerGroup = {
  name: string;
  description?: string;
  filters: {
    __id?: string;
    type: CustomerGroupFilterType;
    values: string[];
  }[];
};

export type BasePrice = {
  type: PriceType;
  value: number;
  stepSize?: number;
};

export type TimePrice = {
  type: 'TIME' | 'PARKING_TIME';
  unit: TimeUnit;
} & BasePrice;

export type DynamicPrice = {
  type: 'DYNAMIC';
  surcharge: number;
  backup: number;
};

type Price = BasePrice | TimePrice | DynamicPrice;

export const PriceTypeValues = [
  'TIME',
  'ENERGY',
  'FLAT',
  'PARKING_TIME',
  'DYNAMIC',
] as const;
export type PriceType = (typeof PriceTypeValues)[number];

export const TimeUnitValues = ['HOUR', 'MINUTE'] as const;
export type TimeUnit = (typeof TimeUnitValues)[number];

export const AuthorizationMethodValues = [
  'ALL',
  'CHARGE_CARD',
  'SCAN_TO_PAY',
  'TAP_TO_PAY',
] as const;
export type AuthorizationMethod = (typeof AuthorizationMethodValues)[number];

export const CustomerGroupFilterTypeValues = [
  'ACCOUNT',
  'CONSUMER_CARD_BILLING_PLAN',
  'INFRA_TOKEN_PROVIDER',
  'ISSUER_NAME',
  'UID',
  'USER',
] as const;
export type CustomerGroupFilterType =
  (typeof CustomerGroupFilterTypeValues)[number];

// TODO: would like to make this the default type for DropdownField
export type DropdownOption<Value = string> = {
  key: string;
  text: string;
  value: Value;
};
